import React, { Dispatch, SetStateAction } from "react";

import ElementsTableWrapper from "./ElementsTableWrapper";

import { SelectedElement } from "../../../../reducers/uploadedBoard";
import ElementsRow from "./ElementsRow";
import { GroupedElements } from "../../../../utils/hooks/commonly-stored/uploaded-board/billOfMaterials";

const ElementsTable = ({
  allElements,
  setSelectedElement,
  disableEditing,
}: {
  allElements: GroupedElements[];
  setSelectedElement: Dispatch<SetStateAction<SelectedElement | null>>;
  disableEditing: boolean;
}) => {
  return (
    <ElementsTableWrapper>
      {allElements.map(({ elements }) => {
        return (
          <ElementsRow
            key={elements[0]!.id}
            elements={elements}
            setSelectedElement={setSelectedElement}
            disableEditing={disableEditing}
          />
        );
      })}
    </ElementsTableWrapper>
  );
};

export default ElementsTable;
